import React from 'react'

const SvgTerminalMinimize = ({className, onClick}) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/></svg>
  )
}

export default SvgTerminalMinimize